<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<module-form :module-id="id" :code-app="codeApp" />
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import moduleForm from '@/components/modules/module-form';

function closeModal() {
	this.goTo('page-module');
}

function title() {
	const module = 'Módulo';
	return this.id ? `Editar ${module}` : `Crear ${module}`;
}

export default {
	name: 'page-module-new',
	components: {
		actionSidebar,
		moduleForm,
	},
	computed: {
		title,
	},
	methods: {
		closeModal,
	},
	props: {
		codeApp: {
			type: String,
			required: true,
		},
		id: {
			type: [Number, String],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/modules/page-module-new.vue